import { Module, Mutation, Action } from "vuex-module-decorators";
import { BountyStatusEnums } from "@/enums/growth";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest, handlePaginationData } from "@/utils/request";
import { getMyBonusAccount } from "@/graphql/bounty.gql";
import {
  queryPromotionCoupon,
  queryPromotionCouponCount
} from "@/graphql/coupon.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import {
  DateClass,
  formatByDate,
  getDateBefore36,
  FORMAT_DATE_SMALL
} from "@/utils/common/date";
import type { PaginationDataState } from "@/types";

export interface MallMyBondState extends PaginationDataState {
  searchCondition: any;
}

@Module({ name: "MallMyBondModule", namespaced: true })
export default class MallMyBondModule
  extends PaginationModule<MallMyBondState, RootState>
  implements MallMyBondState {
  public listData: any[] = [];
  public searchCondition: any = {}; // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据
  public userBounty: any = {};

  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setUserBountyMutation(data: any) {
    this.userBounty = data || {};
  }

  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = {};
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap[key] = value;
    }
  }

  @Action
  async queryListAction({ callback }) {
    const {
      state: {
        searchCondition,
        paginationData,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;
    const [start, end] = getDateBefore36();
    let { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: queryPromotionCoupon,
        variables: {
          // ...searchCondition,
          status: "1",
          beginTime:
            (searchCondition.startTime &&
              formatByDate(
                DateClass.normal(searchCondition.startTime).toDate(),
                FORMAT_DATE_SMALL
              )) ||
            formatByDate(start, FORMAT_DATE_SMALL),
          endTime:
            (searchCondition.endTime &&
              formatByDate(
                DateClass.normal(searchCondition.endTime).toDate(),
                FORMAT_DATE_SMALL
              )) ||
            formatByDate(end, FORMAT_DATE_SMALL),
          pageInput: { pageNum, pageSize }
        }
      })
    );
    // 构造createTime字段
    data = data.map(item => {
      item.createTime = formatByDate(
        DateClass.small(item.receivedTime).toDate()
      );
      return item;
    });
    data = await callback(data);
    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryFilterDataAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "BONUS_SOURCE", // 奖励金筛选
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("setFilterDataMutation", data);
  }

  // 查询用户奖励金
  @Action
  async getMyBonusAccountAction(variables) {
    const data = await queryRequest({
      query: getMyBonusAccount,
      variables
    });
    this.context.commit("setUserBountyMutation", data);
  }

  @Action
  async queryListSumAction(variables: Object) {
    const data = await queryRequest({
      query: queryPromotionCouponCount,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", {
        key: String(o.month).replace(/-/gi, ""),
        value: o
      });
    });
  }
}
